export const global_settings = {
  defaultExchangeRate: "1.16",
  enablePayments: false,
  enableAdminPannel: false,
  enableBetaUIElements: true,
  enableMobileAppBlueBanner: true,
};
